/* src/modules/locations/Scene.js */

import React from 'react';

import LocationCard from './cards/LocationCard';

class Locations extends React.Component {
  constructor(props) {
    super(props);
    this.lol = {};
    // this.state = { open: false, mode: 'add' };
  }

  // _toggleAddCard(type) {
  //   return mode => this.setState({ open: type, mode });
  // }
  lol() {}

  render() {
    return (
      <React.Fragment>
        <LocationCard />
      </React.Fragment>
    );
  }
}

export default Locations;



// WEBPACK FOOTER //
// ./src/modules/locations/Scene.js